import Article from './components/Articles';

export default ({ news }) => {
  return <Article news={news} />;
};

export async function getServerSideProps() {
  const response = await fetch(`${process.env.API_URL}/api/news`);
  const news = await response.json();
  return { props: { news } };
}
